/** Shared shell for Intelligence Discovery Feed result cards (solid dark — sharper than heavy glass blur). */
export const FEED_CARD_SHELL =
  'feed-result-card group relative z-[1] flex flex-col overflow-hidden rounded-xl border border-white/10 bg-slate-900 p-2.5 shadow-lg shadow-black/25 transition-all duration-300 ease-in-out hover:border-cyan-500/30 sm:p-3.5';

/** PRIMARY TARGET — full cyan frame (#00E5FF) for hierarchy above verified peers. */
export const FEED_CARD_PRIMARY =
  'feed-result-card--primary border-2 border-[#00E5FF] bg-slate-900 shadow-[0_0_28px_rgba(0,229,255,0.22)] ring-1 ring-[#00E5FF]/40 pl-4 sm:pl-5';

export const FEED_LINK =
  'text-[#00E5FF] underline decoration-[#00E5FF]/45 underline-offset-2 transition-all duration-300 ease-in-out hover:text-[#7df9ff] hover:decoration-[#7df9ff]/55';

export const FEED_TITLE =
  'text-sm font-bold leading-snug text-slate-50 break-words line-clamp-2 sm:text-base md:text-lg';

export const FEED_META =
  'text-[11px] font-bold uppercase tracking-[0.08em] text-slate-300 sm:text-xs sm:tracking-[0.1em]';

export const FEED_CHIP =
  'inline-flex max-w-full items-center truncate rounded-md border border-white/15 bg-slate-950/80 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-200 transition-all duration-300 ease-in-out';

export const FEED_INSPECT_BTN =
  'feed-inspect-btn inline-flex h-9 min-h-0 w-full shrink-0 items-center justify-center rounded-md border border-cyan-500/40 bg-cyan-500/15 px-2.5 py-1 text-xs font-bold uppercase tracking-wider text-cyan-100 transition-all duration-300 ease-in-out hover:border-cyan-400/70 hover:bg-cyan-500/25 hover:text-cyan-50 sm:h-8 sm:w-auto sm:text-[13px]';

/** Corporate DD section headers — high contrast in light and dark themes. */
export const DD_SECTION_DESC =
  'mt-1 text-[11px] font-semibold leading-relaxed text-slate-700 dark:text-slate-300 sm:text-sm';

export const DD_SECTION_TITLE_BASE =
  'text-[11px] font-black uppercase tracking-[0.14em] sm:text-xs sm:tracking-[0.16em]';

export const DD_SECTION_TITLE = {
  indigo: `${DD_SECTION_TITLE_BASE} text-indigo-950 dark:text-indigo-100`,
  violet: `${DD_SECTION_TITLE_BASE} text-violet-950 dark:text-violet-100`,
  cyan: `${DD_SECTION_TITLE_BASE} text-cyan-950 dark:text-cyan-100`,
  sky: `${DD_SECTION_TITLE_BASE} text-sky-950 dark:text-sky-100`,
  emerald: `${DD_SECTION_TITLE_BASE} text-emerald-950 dark:text-emerald-100`,
  rose: `${DD_SECTION_TITLE_BASE} text-rose-950 dark:text-rose-100`,
  teal: `${DD_SECTION_TITLE_BASE} text-teal-950 dark:text-teal-100`,
};
